import { render, staticRenderFns } from "./studentList.vue?vue&type=template&id=b7ab00bc&scoped=true&"
import script from "./studentList.vue?vue&type=script&lang=ts&"
export * from "./studentList.vue?vue&type=script&lang=ts&"
import style0 from "./studentList.vue?vue&type=style&index=0&id=b7ab00bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ab00bc",
  null
  
)

export default component.exports